export const createDocumentationUrl = (path: string): string =>
  `https://docs.smartbotpro.ru/${path}`;

export const LANDING_DOMAIN = 'smartbotpro.ru';
export const LANDING_LINK = `https://${LANDING_DOMAIN}/`;

export const DOCUMENTATION_LINK = createDocumentationUrl('');

export const documentationLinks = {
  vars: {
    all: createDocumentationUrl('scenarii/peremennye'),
    special: createDocumentationUrl(
      'scenarii/peremennye/specialnye-peremennye'
    ),
    global: createDocumentationUrl('scenarii/peremennye/globalnye-peremennye'),
    local: createDocumentationUrl(
      'scenarii/peremennye/polzovatelskie-peremennye'
    )
  },
  buttons: createDocumentationUrl(
    'scenarii/deistviya/otpravit-soobshenie/knopki'
  ),
  channel: createDocumentationUrl('nachalo-raboty/kak-podklyuchit-messendzher'),
  importProducts: createDocumentationUrl(
    'instrumenty-rosta/magaziny-vnutri-telegram/import-tovarov-iz-excel-faila'
  ),
  attachments: createDocumentationUrl(
    'scenarii/deistviya/otpravit-soobshenie#vlozheniya'
  ),
  chatMessageEvent: createDocumentationUrl(
    'scenarii/sobytiya-scenariya/soobshenie-ot-polzovately'
  ),
  contactOffer: createDocumentationUrl('dokumenty/dogovor-publichnoi-oferty'),
  socialNetwork: createDocumentationUrl(
    'nachalo-raboty/kak-podklyuchit-messendzher/privyazka-akkaunta-socialnoi-seti'
  ),
  addingTgChannel: createDocumentationUrl(
    'nachalo-raboty/kak-podklyuchit-messendzher/podklyuchenie-telegram'
  ),
  addingTgBot: createDocumentationUrl(
    'nachalo-raboty/kak-podklyuchit-messendzher/podklyuchenie-telegram/dobavlenie-bota-v-gruppovoi-chat-v-telegram'
  ),
  addingTgBusiness: createDocumentationUrl(
    'nachalo-raboty/kak-podklyuchit-messendzher/podklyuchenie-telegram/podklyuchenie-telegram-business'
  ),
  yookassa: createDocumentationUrl(
    'scenarii/integracii/yukassa-dlya-priema-platezhei'
  ),
  getCourse: createDocumentationUrl('scenarii/integracii/get-course'),
  payments: createDocumentationUrl('scenarii/priem-oplaty'),
  tinkoffPayment: createDocumentationUrl(
    'scenarii/priem-oplaty/priem-oplaty-cherez-tinkoff'
  ),
  cloudPayments: createDocumentationUrl(
    'scenarii/priem-oplaty/cloud-payments-dlya-priema-platezhei'
  ),
  webhook: createDocumentationUrl('scenarii/sobytiya-scenariya/webhook'),
  httpRequest: createDocumentationUrl('scenarii/integracii/http-zapros'),
  googleTables: createDocumentationUrl('scenarii/integracii/google-tablicy'),
  addingViberBot: createDocumentationUrl(
    'nachalo-raboty/kak-podklyuchit-messendzher/podklyuchenie-viber'
  ),
  amoCRM: createDocumentationUrl('scenarii/integracii/amocrm'),
  bitrix24: createDocumentationUrl('scenarii/integracii/bitrix24'),
  // blocks
  notifyManagers: createDocumentationUrl(
    'scenarii/deistviya/otpravit-uvedomlenie'
  ),
  switchContext: createDocumentationUrl('scenarii/deistviya/smenit-kontekst'),
  conditionSwitch: createDocumentationUrl(
    'scenarii/usloviya/mnozhestvennye-usloviya'
  ),
  tooManyBlocks: createDocumentationUrl(
    'nachalo-raboty/podrobnee-o-scenariyakh'
  ),
  setTimer: createDocumentationUrl(
    'scenarii/deistviya/zaplanirovannye-perekhody'
  ),
  portalOut: createDocumentationUrl(
    'scenarii/deistviya/perekhod-v-drugoi-scenarii'
  ),
  removeFromList: createDocumentationUrl(
    'scenarii/deistviya/rabota-s-polzovatelem'
  ),
  addToList: createDocumentationUrl('scenarii/deistviya/rabota-s-polzovatelem'),
  executeSq: createDocumentationUrl('scenarii/deistviya/vypolnit-smartquery'),
  sendStats: createDocumentationUrl('scenarii/deistviya/zapisat-v-statistiku'),
  extractData: createDocumentationUrl('scenarii/deistviya/izvlech-dannye'),
  isGroupMember: createDocumentationUrl(
    'scenarii/usloviya/usloviya-vkontakte#proverka-podpiski'
  ),
  basic: createDocumentationUrl('scenarii/usloviya/prostye-usloviya'),
  userInput: createDocumentationUrl('scenarii/deistviya/obrabotat-soobshenie'),
  setVar: createDocumentationUrl('scenarii/deistviya/ustanovit-peremennuyu'),
  chatMessage: createDocumentationUrl(
    'scenarii/sobytiya-scenariya/soobshenie-ot-polzovately'
  ),
  sendMessage: createDocumentationUrl('scenarii/deistviya/otpravit-soobshenie'),
  // pre_filter
  preFilter: createDocumentationUrl(
    'scenarii/sobytiya-scenariya/filtr-predobrabotki'
  ),
  firstMessage: createDocumentationUrl(
    'scenarii/sobytiya-scenariya/pervoe-soobshenie'
  ),
  defaultAnswer: createDocumentationUrl(
    'scenarii/sobytiya-scenariya/net-podkhodyashego-scenariya'
  ),

  debugMode: createDocumentationUrl('nastroiki/proekty#rezhim-otladki'),
  eventsQueueMode: createDocumentationUrl(
    'nastroiki/proekty#poryadok-obrabotki-soobshenij'
  ),
  globalInput: createDocumentationUrl(
    'scenarii/sobytiya-scenariya/soobshenie-ot-polzovately#globalnyj-vhod'
  ),
  sendMessageExtraSettings: createDocumentationUrl(
    'scenarii/deistviya/otpravit-soobshenie#dopolnitelnye-nastroiki-deistviya-otpravit-soobshenie'
  ),
  amoCRMAddLead: createDocumentationUrl(
    'scenarii/integracii/amocrm/blok-sozdat-sdelku'
  ),
  amoCRMEditLead: createDocumentationUrl(
    'scenarii/integracii/amocrm/blok-izmenit-sdelku'
  ),
  createJivoChannel: createDocumentationUrl(
    'nachalo-raboty/kak-podklyuchit-messendzher/podklyuchenie-jivo'
  ),
  createWazzupChannel: createDocumentationUrl(
    'nachalo-raboty/kak-podklyuchit-messendzher/podklyuchenie-wazzup'
  ),
  menuForTgBot: createDocumentationUrl('scenarii/menyu-dlya-telegram-bota'),
  privacyPolicy: createDocumentationUrl('dokumenty/politika-konfidencialnosti'),
  userAgreement: createDocumentationUrl('dokumenty/polzovatelskoe-soglashenie'),
  marketingConsent: createDocumentationUrl(
    'dokumenty/soglasie-na-obrabotku-personalnykh-dannykh-dlya-marketingovykh-kommunikacii'
  ),
  smartbotAI: createDocumentationUrl('instrumenty/smartbot-ai'),
  connectChannel: createDocumentationUrl(
    'nachalo-raboty/kak-podklyuchit-messendzher/podklyuchenie-kanala-k-scenariyu'
  ),
  createShop: createDocumentationUrl(
    'instrumenty/magaziny-v-telegram/sozdanie-kataloga'
  ),
  telegramStars: createDocumentationUrl(
    'scenarii/priem-oplaty/priem-oplaty-s-pomoshyu-telegram-stars'
  ),
  paymentSystemConnection: createDocumentationUrl(
    'scenarii/priem-oplaty/podklyuchenie-platezhnoi-sistemy'
  ),
  nocodeCloud: createDocumentationUrl('nocode-cloud/korotko-o-glavnom'),
  tariffsAndPrices: createDocumentationUrl(
    'dokumenty/podpiska-i-tarify/tarify-i-ceny'
  ),
  tariffs: createDocumentationUrl('dokumenty/podpiska-i-tarify'),
  aiBotPayment: createDocumentationUrl(
    'dokumenty/podpiska-i-tarify/kak-rabotaet-oplata-ai-botov'
  ),
  agentPlatform: createDocumentationUrl('scenarii/integracii/agent-platform')
};

export const LINK_TO_BLOG = `https://${LANDING_DOMAIN}/blog`;

export const LINK_TO_VK = 'https://vk.com/smartbot';
export const LINK_TO_TG = 'https://t.me/smartbotteam';
export const LINK_TO_VC_RU = 'https://vc.ru/id1697857';

export const API_QIWI_LINK = 'https://qiwi.com/api';

export const YOOMONEY_NOTIFICATIONS_LINK =
  'https://yoomoney.ru/transfer/myservices/http-notification';

export const AGENT_PLATFORM_LINK =
  'https://agentplatform.ru?utm_source=smartbot';

export const BOT_FATHER_LINK = 'https://t.me/BotFather';
export const MAX_CREATE_BOT_LINK =
  'http://business.max.ru/self/?utm_source=smartbot';
export const VIBER_PARTNERS_LINK = 'https://partners.viber.com';
export const CREATE_REFERRAL_LINK =
  'https://t.me/partnership_smartbot?start=sitelk';

export const ELAMA_SUPPORT_MAIL_LINK = 'milo@elama.ru';

export const SUPPORT_MAIL_LINK = 'help@support.smartbotpro.ru';

export const CREATE_VK_GROUP_LINK = 'https://vk.com/groups?w=groups_create';

export const JIVO_SUPPORT_LINK = 'info@jivosite.com';

export const JIVO_LINK = 'jivo.ru';

export const VC_RU_LINK = 'https://vc.ru/';

export const TG_PAYMENTS_AVAILABLE_CURRENCIES_LINK =
  'https://core.telegram.org/bots/payments#supported-currencies';

export const TG_PAYMENTS_STARS_LINK =
  'https://core.telegram.org/bots/payments-stars';

export const wazzupLinks = {
  referal: 'https://wazzup24.com/?utm_p=JvmidV',
  whatsappWabaDiff:
    'https://wazzup24.ru/help/how-to-configurate/waba-i-whatsapp/',
  connect: {
    waba: 'https://wazzup24.ru/help/how-to-configurate/add-a-whatsapp-api-singapore-channel/',
    whatsapp:
      'https://wazzup24.ru/help/how-to-configurate/podkljuchenie-whatsapp-personal/',
    ig: 'https://wazzup24.ru/help/how-to-configurate/podkljuchit-instagram-api/',
    tgBot: 'https://wazzup24.ru/help/how-to-configurate/telegram-bot/',
    tgPersonal:
      'https://wazzup24.ru/help/how-to-configurate/telegram-personal/',
    avito: 'https://wazzup24.ru/help/how-to-configurate/kak-podkljuchit-avito/'
  },
  howConnect: 'https://wazzup24.ru/help/api-ru/sposoby-podkljucheniya/'
};

export const YANDEX_FOUNDATION_MODELS_LINK =
  'https://yandex.cloud/en/docs/foundation-models/concepts/';

export const PERSONAL_MANAGER_LINK = 'https://t.me/VladimirSmartBotPro';

export const PORTAL_IDS = {
  DRAG_LAYER_ID: 'drag-layer',
  MODALS: 'modals',
  SIDE_WINDOW: 'side-window',
  POPUPS: 'popup-root',
  YANDEX_METRIKA: '__yandex_metrika__',
  LIST_PAGE_BUTTONS: 'list-page-buttons'
};

export const MAIN_ELEMENTS_ID = {
  GRAPH_CONTAINER: '__graph_container__',
  SIDE_WINDOW_CONTAINER: '__side-window-container__'
};

export const CLOUDPAYMENTS_ACCOUNT = 'https://merchant.cloudpayments.ru/';
